import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putUser = (token, id, TenantID, UserID, TenantRole, TenantEmployeeID) => {
    const body = {}

    if(TenantID) {
        body.TenantID = TenantID
    }

    if(UserID) {
        body.UserID = UserID
    }

    if(TenantRole) {
        body.TenantRole = TenantRole
    }
    
    if(TenantEmployeeID) {
        body.TenantEmployeeID = TenantEmployeeID
    }

    return fetch(`${apiUrl}user_tenant_connections/${id}`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    });
}

export default putUser